import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import ClearIcon from "@material-ui/icons/Clear";
import grey from "@material-ui/core/colors/grey";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";

const useStyle = makeStyles((theme) => ({
  color: {
    height: 8,
  },
  shadow: {
    zIndex: 10000,
    transition: "box-shadow 0.1s ease-in-out",
  },
  mobileFriendly: {
    display: "flex",
  },
  filler: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
    padding: theme.spacing(2),
    paddingRight: theme.spacing(1),
    margin: 0,
    color: theme.palette.primary.main,
    fontSize: 24,
    lineHeight: "30px",
    fontWeight: 300,
    marginBottom: 6,
  },
  subTitle: {
    flexGrow: 1,
    flexBasis: 0,
    padding: theme.spacing(2),
    paddingTop: 0,
    paddingRight: theme.spacing(1),
    margin: 0,
    marginTop: -theme.spacing(1.5),
    color: grey[500],
    fontSize: 15,
    fontWeight: 400,
    lineHeight: "19px",
  },
  iconButton: {
    margin: theme.spacing(0.75),
    marginLeft: 0,
    alignSelf: "flex-start",
  },
}));

function DialogTitle(props) {
  const { className, title, subTitle, onClose, menu, color } = props;
  const classes = useStyle(props);

  return (
    <div className={clsx(classes.shadow, className)}>
      <div className={classes.mobileFriendly}>
        {color && <div className={classes.color} style={{ background: color }} />}
        <Typography className={classes.title}>{title}</Typography>
        {menu && <div className={classes.iconButton}>{menu}</div>}
        {onClose && (
          <IconButton className={classes.iconButton} onClick={onClose}>
            <ClearIcon />
          </IconButton>
        )}
      </div>
      {subTitle && <Typography className={classes.subTitle}>{subTitle}</Typography>}
    </div>
  );
}

DialogTitle.propTypes = {
  /** Class name applied to dialog title */
  className: PropTypes.string,
  /** Title of dialog */
  title: PropTypes.string,
  /** SubTitle of Dialog */
  subTitle: PropTypes.string,
  /** Callback fired when closing dialog */
  onClose: PropTypes.func,
  /** Menu component to display next to close button */
  menu: PropTypes.node,
  /** Color of dialog */
  color: PropTypes.string,
  /** Vertical scroll position of dialog content */
  scrollY: PropTypes.number,
  /** If true, don't wrap the title */
  noWrap: PropTypes.bool,
};

export default DialogTitle;



// WEBPACK FOOTER //
// ./src/components/DialogTitle.jsx